import { RefObject, useCallback } from 'react'
import { LightGallery as ILightGallery } from 'lightgallery/lightgallery'
import { LightGalleryProps } from 'lightgallery/react'

type Props = {
  lightGalleryRef: RefObject<ILightGallery | null>
}

type Returned = NonNullable<LightGalleryProps['onInit']>

export const useOnInit = (props: Props): Returned => {
  const { lightGalleryRef } = props

  return useCallback<Returned>(
    (detail) => {
      if (detail) {
        lightGalleryRef.current = detail.instance
        if (!lightGalleryRef.current?.lgOpened) {
          requestAnimationFrame(() => {
            lightGalleryRef.current?.openGallery()
          })
        }
      }
    },
    [lightGalleryRef]
  )
}
